export default __webpack_public_path__ + "static/media/shadow_prototypes.9d9a56c9.jpg";